import { PenNameSearchSelect } from './PenNameSearchSelect'
import { withPenNameSearchSelect } from './withPenNameSearchSelect'

const ConnectedPenNameSearchSelect =
  withPenNameSearchSelect(PenNameSearchSelect)

export { ConnectedPenNameSearchSelect as PenNameSearchSelect }
